import { render } from "./TabRole.vue?vue&type=template&id=cf80602e&scoped=true"
import script from "./TabRole.vue?vue&type=script&lang=js"
export * from "./TabRole.vue?vue&type=script&lang=js"

import "./TabRole.vue?vue&type=style&index=0&id=cf80602e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf80602e"]])

export default __exports__